import { DynamicModule } from '1-project/DynamicModule/DynamicModule';
import { UI_Tabs } from 'ui/components/3-organisms/Tabs/Tabs';

export const Tabs = ({ id, content, settings }: Content.Tabs) => {
	const { tabsTitle, tabSections } = content ?? {};
	const { width, hideTitle } = settings?.properties ?? {};
	return (
		<UI_Tabs
			tabsTitle={tabsTitle}
			tabs={tabSections?.map((tab) => {
				const { title, content } = tab?.content?.properties ?? {};
				return {
					id: `${id}-${title?.toLowerCase().replaceAll(' ', '-')}`,
					title: title,
					content: content?.map((sectionModule, index) => <DynamicModule key={index} module={sectionModule} />),
				};
			})}
			hideTitle={hideTitle}
			width={width}
		/>
	);
};
